/**
 * Per-widget-type DOM transforms for downloadWidgetAsImage.
 *
 * Each entry is keyed by the widget `comp` name and exposes:
 *   prepare(container)  – mutate the DOM before capture, return a restore fn
 *
 * The restore function is called in a finally block so the UI reverts even if
 * the capture throws.
 */

import { prepareHeatMapGrid } from "./heatMapGrid";
import { prepareAnnotationExplorer } from "./annotationExplorer";
import { prepareAskAI } from "./askAI";
import { preparePieChart } from "./pieChart";

export const captureTransforms = {
  HeatMapGrid: prepareHeatMapGrid,
  WidgetAnnotationExplorer: prepareAnnotationExplorer,
  WidgetAskAI: prepareAskAI,
  WidgetPieChart: preparePieChart,
};
